"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.VisuallyHidden = exports.setWiderBorderColour = exports.setBorderColour = exports.setBoxShadow = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const setBoxShadow = (colour) => `inset 0px 3px 0px ${colour}`;
exports.setBoxShadow = setBoxShadow;
/**
 * @deprecated Use 1px solid var(--ds-color-xyz) instead
 */
const setBorderColour = (colour) => `1px solid ${colour}`;
exports.setBorderColour = setBorderColour;
const setWiderBorderColour = (colour) => `2px solid ${colour}`;
exports.setWiderBorderColour = setWiderBorderColour;
/**
 * Screenreader only element. Defaults to div but
 * can be rendered as any element using the `as` prop
 */
exports.VisuallyHidden = styled_components_1.default.div `
    position: absolute;
    left: -10000px;
    top: auto;
    width: 1px;
    height: 1px;
    overflow: hidden;
`;
//# sourceMappingURL=helpers.js.map